/* global Swiper */
// *******************************************************************************
// 1.0 - Text Over Image
// *******************************************************************************

const textOverImageSliderElements = document.querySelectorAll('[data-slider="text-over-image-slider"]');

const textOverImageSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 20,
  watchOverflow: true,
  loop: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  preloadImages: false,
  lazy: {
    checkInView: true,
    loadPrevNextAmount: 1,
    loadPrevNext: true,
  },
  navigation: {
    prevEl: '.swiper-button-next'
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'fraction',
    clickable: true,
    renderFraction(currentClass, totalClass) {
      return `<span class="${currentClass}"></span><span> — </span><span class="${totalClass}"></span><span></span>`;
    },
  },
};

textOverImageSliderElements.forEach((el) => {
  const textOverImageParent = el.closest('.sc-text-over-image');
  const arrowRight = textOverImageParent.querySelector('.arrow-right');
  const paginationElement = textOverImageParent.querySelector('.swiper-pagination');
  const textOverImageSlides = textOverImageParent.querySelectorAll('.swiper-slide');
  const textOverImageSliderNav = textOverImageParent.querySelector('.text-over-image__nav');

  if (textOverImageSlides.length === 1) {
    textOverImageSliderNav.classList.add('hide');
    textOverImageSliderOptions.loop = false;
  }

  textOverImageSliderOptions.navigation.nextEl = arrowRight;
  textOverImageSliderOptions.pagination.el = paginationElement;

  // eslint-disable-next-line no-new
  new Swiper(el, textOverImageSliderOptions);
});

